import * as React from 'react'

import { observer } from 'mobx-react'

import { Button } from '~/client/src/shared/components/shadcn-ui/button'
import { Checkbox } from '~/client/src/shared/components/shadcn-ui/checkbox'
import {
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '~/client/src/shared/components/shadcn-ui/dialog'
import Localization from '~/client/src/shared/localization/LocalizationManager'

import MaterialsUploadStore from '../MaterialsUpload.store'

// translated

interface IProps {
  store: MaterialsUploadStore
}

@observer
export default class ChooseMaterialsSheetDialog extends React.Component<IProps> {
  public render() {
    const {
      isChooseSheetDialogShown,
      resetInitialValues,
      uploadedSheets,
      chosenSheetName,
      selectedSheet,
      applyChooseSheetDialog,
      chooseSheetName,
    } = this.props.store

    return (
      <Dialog open={isChooseSheetDialogShown}>
        <DialogContent showCloseButton={false}>
          <DialogHeader>
            <DialogTitle>{Localization.translator.chooseSheet}</DialogTitle>
          </DialogHeader>
          <div className="relative">
            <div className="text large light mb40">
              {Localization.translator.materialsUploading.pleaseSelectSheetToUpload(
                uploadedSheets.length > 1,
              )}
            </div>
            {uploadedSheets.map((sheet, index) => (
              <div
                key={sheet.name + index}
                className="row mb5 pointer"
                onClick={chooseSheetName.bind(null, sheet.name)}
              >
                <div
                  className="row y-center no-flex-children"
                  title={sheet.name}
                >
                  <Checkbox checked={chosenSheetName === sheet.name} />
                  <span className="tw:ml-2">{sheet.name}</span>
                </div>
                <div className="text large light no-grow nowrap mx10">
                  {Localization.translator.xColumns(sheet.columns.length)}
                </div>
              </div>
            ))}
            <div className="text large light mb20" />
          </div>

          <DialogFooter>
            <Button
              variant="outline"
              className="tw:grow"
              onClick={resetInitialValues}
            >
              {Localization.translator.cancel}
            </Button>
            <Button
              variant="default"
              className="tw:grow"
              disabled={!selectedSheet}
              onClick={applyChooseSheetDialog}
            >
              {Localization.translator.next}
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    )
  }
}
